import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import PageSection from '../PageSection';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Image from 'next/image';
import ActionButton from 'components/ActionButton';
import ImageZoom from '../ImageZoom';

const useStyles = makeStyles(theme => ({
  root: {},
  topText: {
    fontSize: 16,
    color: '#ffffff',
    textTransform: 'uppercase',
  },
  title: {
    fontSize: 34,
    lineHeight: 1.35,
    color: '#ffffff',
  },
  text: {
    color: '#ffffff',
  },
}));

const HighlightedImageSection = ({
  topTitle,
  title,
  text,
  image,
  imageAlt,
  actionLink,
  textSide,
  actionText,
  children,
  textSplitSize,
  ...props
}) => {
  const classes = useStyles();

  return (
    <PageSection style={{ backgroundImage: 'linear-gradient(104deg, #5294ff, #5764ff)' }} {...props}>
      <Container maxWidth="md">
        <Grid container spacing={2} justifyContent="center">
          <Grid item md={textSplitSize}>
            <Grid container direction="column" spacing={1}>
              {topTitle && (
                <Grid item>
                  <Typography variant="h5" color="textSecondary" className={classes.topText}>
                    {topTitle}
                  </Typography>
                </Grid>
              )}

              <Grid item>
                <Typography variant="h3" color="textSecondary" className={classes.title} paragraph>
                  {title}
                </Typography>
              </Grid>

              <Grid item>
                <Typography variant="caption" color="textSecondary" className={classes.text} paragraph>
                  {text}
                  {children}
                </Typography>
              </Grid>
              {actionText && (
                <Grid item md={12}>
                  <ActionButton justify={'flex-start'} link={actionLink} text={actionText} color={'secondary'} />
                </Grid>
              )}
            </Grid>
          </Grid>

          <Grid item md={12 - textSplitSize}>
            <ImageZoom>
              <Image unoptimized={true} src={image} alt={imageAlt} width={604} height={315} />
            </ImageZoom>
          </Grid>
        </Grid>
      </Container>
    </PageSection>
  );
};

HighlightedImageSection.propTypes = {
  topTitle: PropTypes.string,
  title: PropTypes.string.isRequired,
  text: PropTypes.string,
  image: PropTypes.string.isRequired,
  imageAlt: PropTypes.string.isRequired,
  actionText: PropTypes.string,
  actionLink: PropTypes.string,
  textSplitSize: PropTypes.number,
  textSide: PropTypes.oneOf(['start', 'end']),
};

HighlightedImageSection.defaultProps = {
  textSide: 'start',
  textSplitSize: 4,
};

export default HighlightedImageSection;
